import './radio_group.scss'

function initRadioGroup(
  radioGroup: HTMLElement,
  onValueChange?: (value: string) => void,
) {
  const radios =
    radioGroup.querySelectorAll<HTMLInputElement>('input[type=radio]')
  function handleUpdate() {
    radios.forEach((radio) => {
      radio
        .closest('.radio-card')
        ?.classList.toggle('radio-card--selected', radio.checked)
    })

    const checkedRadio = Array(...radios).filter((radio) => radio.checked)[0]
    onValueChange?.(checkedRadio.value)
  }

  handleUpdate()

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      handleUpdate()
    })
  })
}

export { initRadioGroup }
